import styled from "styled-components";

const StyledSVG = styled.svg`
  path:not(.not_active) {
    fill: ${(props) => props.theme.main || "#212B36"};
  }
  rect:not(.not_active) {
    fill: ${(props) => props.theme.main || "#212B36"};
  }

  circle:not(.not_active) {
    fill: ${(props) => props.theme.main || "#212B36"};
  }

  ellipse:not(.not_active) {
    fill: ${(props) => props.theme.main || "#212B36"};
  }

  .stroke_active {
    stroke: ${(props) => props.theme.main || "#212B36"};
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    display: flex;
  }
`;

export { Wrapper, StyledSVG };
